import React, { useMemo } from "react";
import { useLocation, useRouteMatch } from "react-router";
import { Container } from "reactstrap";
import { useTags } from "..";
import FeedbackListContainer from "../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";
import { FeedbackSortOption } from "../../Feedback/Constants/feedbackEnums";

interface MatchParams {
  tagId?: string;
}

const TagFeedbackList: React.FC = props => {
  const match = useRouteMatch<MatchParams>();
  const tags = useTags();

  const thisTag = useMemo(() => {
    const { tagId } = match.params;
    if (!tags.loadingState.isLoaded || !tagId) {
      return null;
    }
    const tagIdNum = tagId ? parseInt(tagId, 10) : null;

    return tags.tags.find(t => t.id === tagIdNum);
  }, [match.params, tags]);

  return (
    <Container fluid>
      {thisTag && (
        <FeedbackListContainer
          listId={`TAGS_LIST_${thisTag.name}`}
          sort={FeedbackSortOption.DateCreated}
          isAscending={false}
          reorderable
          tags={[thisTag.id]}
          fullscreen
          enableDownload
        />
      )}
    </Container>
  );
};

export default TagFeedbackList;
